import styled from 'styled-components';
import trash from '~/assets/icons/trash.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding-top: 20px;
`;

const StyledTitle = styled(Text)`
	font-weight: 500;
	font-size: 18px;
	text-align: center;
	color: #ffffff;
`;

const StyledPhotoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 375px;
`;

const StyledPhotoWrapper = styled.div`
	cursor: pointer;
`;

const StyledPhoto = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	user-select: none;
	pointer-events: none;
`;

const StyledDeleteButton = styled.div`
	width: 30px;
	height: 30px;
	margin: 0 auto;
	background-image: url(${trash});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 0.3s ease;

	&:hover {
		opacity: 1;
	}
`;

export {
	StyledContainer,
	StyledDeleteButton,
	StyledPhoto,
	StyledPhotoContainer,
	StyledPhotoWrapper,
	StyledTitle,
};
